import React from "react";
import Icon from "./Icon";
import _className from "./className";

export default function SideNavLink({
  href,
  onClick,
  selected,
  icon,
  text,
  className = "",
  disabled,
}) {
  return (
    <a
      href={href}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
          return false;
        }
        onClick(e);
      }}
      {..._className({ selected, [className]: true, disabled })}
      disabled={!!disabled}
    >
      {icon && <Icon symbol={icon} />}
      {text && <span className="text-view">{text}</span>}
    </a>
  );
}
